//模板二首页注册
export const phoneRuleHeader = {
  reg: /^[+]{0,1}(\d+)$/
};
export const emailRuleHeader = {
  // eslint-disable-next-line no-useless-escape
  reg: /(?=^.{3,256}$)^([\w\-]+([\.][\w\-]+)*)@[a-zA-Z0-9][a-zA-Z0-9\-]*[\.][A-Za-z]{2,6}$/
};
